import http from '../common/api';
import {ApiSettings} from "application";

const signOut = async () => {
  return await http.delete(ApiSettings.signOut, { target: 'alf'});
}

export default signOut;
